export const GET_SELECT_COLOR_REQUEST="GET_SELECT_COLOR_REQUEST"
export const GET_SELECT_COLOR_SUCCESS="GET_SELECT_COLOR_SUCCESS"
export const GET_SELECT_COLOR_FAILURE="GET_SELECT_COLOR_FAILURE"